import { AccessDeniedError, UnexpectedError } from "../../domain/errors";
import { UnauthorizedError } from "../../domain/errors/unauthorized-error";
import { ReceiptCheck } from "../../domain/models/receipt-check";
import { LoadReceiptCheck } from "../../domain/usecases/load-receipt-check";
import { HttpClient, HttpStatusCode } from "../protocols/http";

export class DbLoadReceiptCheck implements LoadReceiptCheck {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}
  async load(receiptId: number): Promise<ReceiptCheck> {
    const res = await this.httpClient.request({
      url: this.url,
      method: "get",
      params: { receiptId },
    });
    switch (res.statusCode) {
      case HttpStatusCode.ok:
        return res.body || null;
      case HttpStatusCode.forbidden:
        throw new AccessDeniedError();
      case HttpStatusCode.unauthorized:
        throw new UnauthorizedError();
      default:
        throw new UnexpectedError();
    }
  }
}
